import 'whatwg-fetch';
import { browserHistory } from 'react-router';
import { ACTION_TYPE, ACCOUNT_TYPE } from '../constants';
import { handleError } from './common';
import { otpCode, fetch_csrf_protect } from '../utils';
import { initVerificationAction } from './verification';

export function initGameOTP(region) {
	return dispatch => {
		fetch('/api/account/game_otp/init?region=' + region, {credentials: 'same-origin'})
			.then(response => response.json())
			.then(data => handleInitGameOTP(dispatch, data))
	}
}

export function saveGameOTP(game_id, status) {
    return dispatch => {
		fetch('/api/account/game_otp/save', {
			credentials: 'same-origin',
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				game_id: parseInt(game_id),
				status: status
			})
		})
			.then(response => response.json())
			.then(data => handleSaveGameOTP(dispatch, data))
	}
}

function handleInitGameOTP(dispatch, data) {
    if ('error' in data) {
        handleError(data);
        return;
	}
	switch (data.next_action.action_type) {
		case ACTION_TYPE.TWO_STEP_VERIFICATION:
		{
			dispatch(initVerificationAction(data));
			browserHistory.push('/security/game_otp/2-step-verification');
			break;
		}
		case ACTION_TYPE.SAVE_GAME_OTP:
		{
			let games = data.games;
			browserHistory.push('/security/game_otp/save');
			break;
		}
		default:
			break;
	}
}

function handleSaveGameOTP(dispatch, data) {
    if ('error' in data) {
		handleError(data);
		return;
	}
	if (data.status === 0 && data.next_action.action_type === ACTION_TYPE.DONE) {
		browserHistory.push('/security/game_otp/done');
	}
}



// WEBPACK FOOTER //
// ./app/actions/gameOTP.js